import { createLazyComponent, LazyModule } from 'owa-bundling';
import type { HubListItem, SparseHubListItems } from '../hubListItem';
import type { HubListContextMenuProperties } from '../../../models/hubListContextMenuProperties';

const hubListModule = new LazyModule(() => import(/* webpackChunkName: "HubList" */ './hubList'));

export interface HubListProps {
    readonly entries: HubListItem[];
    readonly sparseEntries?: SparseHubListItems | undefined;
    readonly totalCount?: number;
    readonly activeItemIds: string[];
    readonly disableScrollToHubListGroupMenu?: boolean;
    readonly moreItemsAreLoading: boolean;
    readonly activeLeftNavItemId: string;
    readonly showHubList: boolean;
    readonly showRightPane: boolean;

    readonly onScrollToGroupClicked: (firstItemInGroup: HubListItem) => void;
    readonly onCheckAllItems: () => void;
    readonly onClearAllItems: () => void;
    readonly onDeletePressed: () => void;
    readonly onFocusDebounceHandler: (func: () => void) => void;
    readonly onVisibleEntriesChanged: (visibleEntryIds: string[]) => void;
    readonly onMouseOverHubPersona: (hubPersonaId: string) => void;
    readonly onMouseLeaveHubPersona: () => void;
    readonly onRenderSparseItem?: (itemId: number) => void;
    readonly renderContextMenu: (
        hubListCotextMenuProperties: HubListContextMenuProperties
    ) => JSX.Element;
}

export default createLazyComponent(hubListModule, m => m.default);
